import React from 'react';
import PropTypes from 'prop-types';
import css from './Header.css';
import { Link } from 'react-router-dom';
import Icon from 'SF/MaterialIcon';
import ServiceDropdown from './ServiceDropdown';
import DoorbellButton from './DoorbellButton';

function Header(props) {
  return (
    <header className={css['container']}>
      <div className={css['controls']}>
        <ServiceDropdown
          services={props.services}
          setServices={props.setServices}
          setError={props.setError}
        />
        <DoorbellButton studentsResponseData={props.studentsResponseData} />
      </div>
      <h1 data-role="welcome-title">Welcome to the Waiting Room.</h1>
      <div className={css['details']}>
        <p><b>Last Updated:</b> {props.lastUpdatedDisplay}</p>
        <p>
          When you start a meeting with a student from the queue, 
          the student will be moved to the In Progress Column, and other providers 
          will not be able to start a meeting with that student. 
          You will not be able to make changes to a meeting when it is in progress 
          with another provider. 
        </p>
        <div className={css['button-container']}>
          <Icon icon="today" />
          <Link to="/history">See who checked in today.</Link>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  services: PropTypes.array,
  setServices: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  lastUpdatedDisplay: PropTypes.string,
  studentsResponseData: PropTypes.object.isRequired,
};

export default Header;
